'use strict'

let definition=require('../../definition/labels/norwegian.js').norwegian;

export let norwegian={
  general: {
    output: "leveranse",
    approach: "Tilnærming",
    scope: definition.scope.fields.projectScope.title
  },
  outputSummary: {
    cover: "For å dekke",
    projectWillDeliver: "vil prosjektet levere",
    theReceiverWants: "For denne leveransen, ønsker mottakeren og brukeren at",
    willConfirm: "kommer til å bekrefte at vi har",
    by: "ved"
  },
  output: {
    title: "Leveranse",
    fields: {
      output: {
        title: "Leveranse",
        help: `Når prosjektet er ferdig, hvilke leveranser må være laget og klar for overlevering til noen andre for permanent eierskap?`,
        description: "Beskriv høynivå leveranse prosjektet må produsere for denne delen av omfanget"
      },
      qualityExpectation: {
        title: "Forventninger til kvalitet",
        help: `Finnes det overordnet krav fra brukeren eller kunden? Når eierskap for denne leveransen er overlevert fra prosjektet til permanent eier, hvilke forventninger vil permanent eier ha til egenskapene for denne leveransen?`,
        description: "Beskriv generelle krav til denne leveransen"
      }
    }
  },
  acceptance: {
    title: "Akseptanse",
    fields: {
      acceptanceCriteria: {
        title: "Akseptansekriterier",
        help:`Hva trenger å være på plass for at denne leveransen skal bli vurdert til å være levert? Hvilke mål, standard eller spesifikke egenskaper? Er det noen toleranser for målingen eller standardene?`,
        description:"Beskriv den målbare definisjonen for akseptanse av krav(ene)"
      },
      acceptanceMethod: {
        title: "Akseptansemetode",
        help:`Hvordan vil vi beslutte at leveransen er god nok? Vil vi teste, validere, gjennomgå den eller vil noen bare inspisere og bekrefte?`,
        description:"Metoden som skal brukes for å bekrefte at leveransen møter de målbare kravene"
      },
      acceptanceResponsible: {
        title: "Akseptanseansvarlig",
        help:`Hvem er ansvarlig for å bekrefte akseptanse? Hvem har autoritet til å si "Ja, dette er godt nok"?`,
        description:"Den som skal bekrefte at kravene er oppnådd"
      }
    }
  },
  dependencies: {
    title: "Avhengigheter",
    fields: {
      derivation: {
        title: "Baseres på",
        help:`Finnes det noen rapport brukt som innspill/utgangspunkt? Mandat, design spesifikasjon eller mer detaljert beskrivelse av krav? Eksisterende produkt å bygge videre på?`,
        description:"Beskriv tidligere leveranser som denne leveransen bygger på"
      },
      skills: {
        title: "Nødvendige ferdigheter/kompetanse",
        help:`Er det noen spesielle ferdigheter som er verdt å nevne? Hvilken avdeling, partner eller leverandør er nødvendig for å gi den nødvendige ferdigheten?`,
        description:"Gi en indikasjon på hvilken kompetanse or/eller hvilen avdeling/organisasjon som må stille resurser tilgjengelig"
      }
    }
  },
  projectProductDescription: {
    title:"Leveranser",
    fields: {
      scopeDetails: {
        title:"Oppdeling av omfanget",
        optional:true,
        help:`Del opp dette omfangselementet i de leveransene det innebærer.`,
        columns: {
          output: { title:"Leveranse" },
          qualityExpectation: { title:"Kvalitetsforventning" },
          acceptanceCriteria: { title:"Akseptansekrav" },
          acceptanceMethod: { title:"Akseptansemetode" },
        },
        samples: [
          {output: "Leveranse av eksempel 1"},
          {output: "Leveranse av eksempel 2"}
        ],
        empty: {
          message: "Omfang er ikke definert. Vennligst legg inn omfang i 'Definisjon'."
        },
        options: {
          addEntry: {
            title: "Legg til leveranse"
          }
        }
      }
    }
  },
  qualityManagementApproach: {
    title:" Kvalitetstilnærming",
    description : "Kvalitetstilnærmingen beskriver hvordan kvalitet skal håndteres, inkludert kravstyring. Hva skal vi gjøre for å sikre at produkter er \"egnet til formål\"?",
    fields:{
      process: {
        title: "Prosess og prosedyrer",
        help: `Hvilken metode vil bli brukt til å sørge for at prosjektet:
                a) fanger alle relevante behov og krav?
                b) prioriterer behov og krav riktig?
                c) utvikler riktig løsning for å møte disse behovene og kravene?
               Er det noen standardprosedyrer som skal følges på kravstyring, testing, godkjenning etc.? Er det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor? 
               Hvordan skal vi sørge for at kvalitetsprosedyren følges - at godkjenningene spores? 
               Er datasikkerhet relevant for prosjektets sluttprodukt, og skal prosjektet utføre konsekvensvurdering av personvern?`,
        description:"Beskriv hvilke prosesser prosjektet vil følge for å sikre at alle leveranser passer til formålet."
      },
      tools : {
        title: "Verktøy og teknikker",
        help:`Hvilke teknikker (intervjuer, prototyper, workshops etc.) vil bli brukt for å sikre at vi lager det rette produktet? Hvilke teknikker vil bli brukt til å sikre at vi gjør produktet riktig? (vurderinger, tester) 
              Hvor skal behov og krav bli organisert, detaljert og prioritert?
              Hvor blir testplaner, testprotokoller og testrapporter organisert og kontrollert?
              Eventuelle standarder eller maler som skal brukes?
              Vil et kvalitetsregister bli brukt? Hvis ja, er det det eneste verktøyet som brukes til å spore kvalitetshandlinger og godkjenninger? Hvis nei, hva vil bli brukt i stedet?`,
        description: "Beskriv hvilke verktøy eller teknikker som skal brukes for å sikre at alle leveransene passer til formålet."
      },
      reporting: {
        title: "Rapportering",
        help: "Når blir kvaliteten rapportert? Hvor skal kvaliteten rapporteres og hvem vil motta kvalitetsrapporter?",
        description: "Rapporter som skal produseres, deres formål, timing og mottakere."
      },
      timing: {
        title: "Timing av aktiviteter",
        help: "Når skal kvalitetsledelsesaktiviteter gjenomføres? Eventuelle spesifikke aktiviteter i begynnelsen eller begynnelsen / slutten av etapper?",
        description: "Beskriv timingen for kvalitetsstyringsaktiviteter"
      },
      roles:{
        title: "Roller og ansvar",
        help: `Hvem godkjenner prosjektforslag, planer og produktbeskrivelsene?
          Hvem sørger for at detaljerte krav blir tatt? Hvem godkjenner dem?
          Hvem innkaller og organiserer kvalitetsledelsesaktiviteter og vurderinger?
          Hvem lager test / vurdering av planer og rapporter?
          Hvem inngår hva i kvalitetsregisteret og hvem godkjenner?`,
        description: "Definer roller og ansvar for aktivitetene"
      }
    }
  },
  products: {
    title: "Produkter",
  },
  qualityRegister: {
    title: "Kvalitetsregister",
  }
}



// WEBPACK FOOTER //
// ./views/quality/labels/norwegian.js